import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL } from './AuthContext';

export const DEFAULT_THEME = {
  logo_title_color: '#5E376D',
  header_bg: '#ffffff',
  body_bg: '#F6E6E8',
  news_card_bg: '#F7E951',
  schedule_card_bg: '#D4BBDD',
  footer_bg: '#ffffff',
};

const CustomThemeContext = createContext();

export function CustomThemeProvider({ children }) {
  const [themeSettings, setThemeSettings] = useState(DEFAULT_THEME);
  const [loadingTheme, setLoadingTheme] = useState(true);

  const fetchThemeSettings = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/settings.php`);
      const data = await response.json();
      if (data && typeof data === 'object') {
        setThemeSettings(prev => ({ ...prev, ...data }));
      }
    } catch (error) {
      console.error("Errore nel recupero delle impostazioni del tema:", error);
    } finally {
      setLoadingTheme(false);
    }
  };

  useEffect(() => {
    fetchThemeSettings();
  }, []);

  const saveTheme = async (newSettings) => {
    const token = localStorage.getItem('adminToken');
    try {
      const response = await fetch(`${API_BASE_URL}/settings.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newSettings)
      });
      const data = await response.json();
      if (response.ok && data.settings) {
        setThemeSettings(data.settings);
        return { success: true, message: data.message };
      } else {
        return { success: false, error: data.error || "Errore durante il salvataggio." };
      }
    } catch (error) {
      console.error(error);
      return { success: false, error: "Errore di connessione." };
    }
  };

  const resetTheme = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const response = await fetch(`${API_BASE_URL}/settings.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ reset: true })
      });
      const data = await response.json();
      if (response.ok && data.settings) {
        setThemeSettings(data.settings);
        return { success: true, message: data.message };
      } else {
        setThemeSettings(DEFAULT_THEME);
        return { success: true, message: "Colori di default ripristinati in locale." };
      }
    } catch (error) {
      console.error(error);
      setThemeSettings(DEFAULT_THEME);
      return { success: true, message: "Colori di default ripristinati." };
    }
  };

  return (
    <CustomThemeContext.Provider value={{ themeSettings, saveTheme, resetTheme, loadingTheme }}>
      {children}
    </CustomThemeContext.Provider>
  );
}

export function useCustomTheme() {
  return useContext(CustomThemeContext);
}
